export const mockData = {
  hero: {
    title: "Engineering the Future of Climate & Energy",
    subtitle: "Advanced HVAC • Renewable Energy • Smart Systems",
    cta1: "Explore Our Solutions",
    cta2: "Request a Consultation",
    images: [
      "https://customer-assets.emergentagent.com/job_6e17bcf1-720a-494a-ad42-2a2989fe2242/artifacts/84bnlxv0_image.png"
    ]
  },
  about: {
    title: "Pioneering Innovation in Engineering Excellence",
    description: "North Bridge represents the convergence of cutting-edge technology and sustainable engineering. We specialize in next-generation HVAC systems, renewable energy solutions, and intelligent climate control that redefines industry standards across the UK and beyond."
  },
  solutions: [
    {
      id: 1,
      title: "HVAC Systems",
      description: "Residential, Commercial, VRF & CAC systems designed for optimal efficiency and performance",
      icon: "wind"
    },
    {
      id: 2,
      title: "Heat Pumps",
      description: "Energy-efficient heating solutions leveraging renewable technology for sustainable comfort",
      icon: "flame"
    },
    {
      id: 3,
      title: "Renewable Energy",
      description: "Solar panels, inverters, and storage systems for complete energy independence",
      icon: "sun"
    },
    {
      id: 4,
      title: "Pool Climate Systems",
      description: "Advanced heating and climate control solutions for swimming pools and aquatic facilities",
      icon: "waves"
    },
    {
      id: 5,
      title: "Engineering & Design",
      description: "Complete HVAC planning, system design, and execution from concept to completion",
      icon: "settings"
    }
  ],
  expertise: {
    title: "Precision Engineering & System Design",
    description: "Our team delivers comprehensive HVAC design and planning services, ensuring compliance with UK & EU standards while maximizing efficiency and performance.",
    features: [
      "Complete system blueprints and technical specifications",
      "Energy efficiency optimization and load calculations",
      "Regulatory compliance and certification management",
      "Installation oversight and commissioning support"
    ]
  },
  brands: [
    {
      name: "North Bridge",
      image: "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/14bzrmvw_dan%20%284%29.png",
      description: "Premier HVAC & Energy Solutions",
      country: "United Kingdom",
      slug: "north-bridge"
    },
    {
      name: "Welliston",
      image: "https://customer-assets.emergentagent.com/job_6e17bcf1-720a-494a-ad42-2a2989fe2242/artifacts/u0350cpf_jaf%20%288%29.png",
      description: "Advanced Climate Systems",
      country: "United Kingdom",
      slug: "welliston"
    },
    {
      name: "Danford",
      image: "https://customer-assets.emergentagent.com/job_6e17bcf1-720a-494a-ad42-2a2989fe2242/artifacts/izcvcrpr_jaf%20%289%29.png",
      description: "Professional HVAC Equipment",
      country: "United Kingdom",
      slug: "danford"
    },
    {
      name: "Lorenza",
      image: "https://customer-assets.emergentagent.com/job_6e17bcf1-720a-494a-ad42-2a2989fe2242/artifacts/l1trc7df_jaf%20%287%29.png",
      description: "Energy Innovation",
      country: "Italy",
      slug: "lorenza"
    }
  ],
  stats: [
    {
      value: "500+",
      label: "Projects Delivered",
      icon: "briefcase"
    },
    {
      value: "98%",
      label: "Client Satisfaction",
      icon: "award"
    },
    {
      value: "35%",
      label: "Average Energy Savings",
      icon: "trending-up"
    },
    {
      value: "24/7",
      label: "Support Available",
      icon: "headphones"
    }
  ],
  whyChoose: [
    {
      title: "Industry-Leading Expertise",
      description: "Our engineers bring decades of combined experience in HVAC and renewable energy systems",
      icon: "users"
    },
    {
      title: "Cutting-Edge Technology",
      description: "We utilize the latest innovations in climate control and energy management",
      icon: "cpu"
    },
    {
      title: "Sustainable Solutions",
      description: "Every system is designed to minimize environmental impact while maximizing efficiency",
      icon: "leaf"
    },
    {
      title: "Complete Service",
      description: "From initial consultation to ongoing maintenance, we provide end-to-end support",
      icon: "check-circle"
    }
  ],
  brandDetails: {
    "north-bridge": {
      name: "North Bridge",
      country: "United Kingdom",
      tagline: "Engineering Excellence in Climate Control",
      description: "North Bridge represents the pinnacle of HVAC and energy engineering in the UK. As our flagship brand, we deliver comprehensive solutions for residential, commercial, and industrial applications. Our expertise spans complete system design, installation, and maintenance, ensuring optimal performance and efficiency.",
      specialties: [
        "Complete HVAC System Design & Engineering",
        "Commercial VRF & CAC Systems",
        "Residential Climate Control Solutions",
        "Energy Efficiency Optimization",
        "System Integration & Automation",
        "24/7 Maintenance & Support"
      ],
      images: [
        "https://images.unsplash.com/photo-1708449287110-2f2418fb5a62",
        "https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3",
        "https://images.pexels.com/photos/32588555/pexels-photo-32588555.jpeg"
      ],
      stats: {
        projects: "500+",
        experience: "15+ Years",
        satisfaction: "98%"
      }
    },
    "lorenza": {
      name: "Lorenza",
      country: "Italy",
      tagline: "Italian Innovation in Renewable Energy",
      description: "Lorenza brings Italian design excellence and innovation to renewable energy solutions. Specializing in solar technology, energy storage, and sustainable power systems, Lorenza represents the perfect blend of Mediterranean craftsmanship and cutting-edge energy technology. Our Italian heritage drives our commitment to beautiful, efficient, and sustainable energy solutions.",
      specialties: [
        "Premium Solar Panel Systems",
        "Advanced Energy Storage Solutions",
        "Smart Inverter Technology",
        "Grid Integration Systems",
        "Energy Management Platforms",
        "Sustainable Power Solutions"
      ],
      images: [
        "/generated/lorenza.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/xyx98aee_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_56_07%20PM.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/92bgfb1g_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_51_39%20PM.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/8losh3ag_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_54_43%20PM.png"
      ],
      stats: {
        installations: "300+",
        energySaved: "45%",
        countries: "12"
      }
    },
    "welliston": {
      name: "Welliston",
      country: "United Kingdom",
      tagline: "Advanced Climate Systems for Modern Living",
      description: "Welliston is our premium residential and light commercial climate control brand. Born in the UK, Welliston focuses on delivering whisper-quiet, highly efficient heating and cooling solutions. We specialize in heat pump technology, smart climate control, and integrated home comfort systems that blend seamlessly into modern living spaces.",
      specialties: [
        "Residential Heat Pump Systems",
        "Smart Climate Control Technology",
        "Whisper-Quiet Operation Systems",
        "Energy-Efficient Heating Solutions",
        "Swimming Pool Climate Control",
        "Home Automation Integration"
      ],
      images: [
        "/generated/welliston.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/8losh3ag_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_54_43%20PM.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/locvgyt9_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_50_01%20PM.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/41m4wrvz_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_51_17%20PM.png"
      ],
      stats: {
        homes: "1000+",
        efficiency: "35%",
        rating: "4.9/5"
      }
    },
    "danford": {
      name: "Danford",
      country: "United Kingdom",
      tagline: "Professional-Grade HVAC Equipment",
      description: "Danford is our industrial and commercial HVAC equipment brand, engineered for demanding applications. Built to British standards of quality and durability, Danford equipment powers some of the UK's most critical facilities. From hospitals to data centers, Danford delivers reliability when downtime is not an option.",
      specialties: [
        "Industrial HVAC Systems",
        "Commercial Air Handling Units",
        "High-Capacity Cooling Systems",
        "Critical Environment Solutions",
        "Custom Equipment Manufacturing",
        "Industrial Ventilation Systems"
      ],
      images: [
        "/generated/danford.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/locvgyt9_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_50_01%20PM.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/41m4wrvz_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_51_17%20PM.png",
        "https://customer-assets.emergentagent.com/job_future-energy-4/artifacts/92bgfb1g_ChatGPT%20Image%20Jan%207%2C%202026%2C%2012_51_39%20PM.png"
      ],
      stats: {
        facilities: "200+",
        uptime: "99.9%",
        capacity: "50MW+"
      }
    }
  }
};